import React from "react";

import { AmplificationStrategiesDetail } from "../elements/asco-amplification-strategies/detail";
import AmplificationStrategiesBanner from "../elements/asco-amplification-strategies/main-banner";
import ASCOAmplificationStrategiesServicesDetails from "../elements/asco-amplification-strategies/services-slider";
import ASCOWebinarDetails from "../elements/asco-amplification-strategies/webinar-details";
import { ContactSection } from "../elements/contact-section";
import LatestNewsSection from "../elements/latest-news-slider";
import fulgentLogo from "../../images/logos/fulgent.png";
import labcorpLogo from "../../images/logos/labcorp.png";
import mdHealthLogo from "../../images/logos/md-health.png";
import tempusLogo from "../../images/logos/tempus.png";
import ascoConferenceImg from "../../images/banner/ASCO-conference.png";

const RSNA_CLIENTS = [
  {
    client1: {
      logo: "https://media.graphassets.com/output=format:jpg/resize=height:800,fit:max/ZKOtJtBQ431UgtCWFVFg",
      alt: "Agilent Technologies",
    },
    client2: { logo: tempusLogo, alt: "Tempus AI" },
  },
  {
    client1: { logo: mdHealthLogo, alt: "MD Health" },
    client2: {
      logo: "https://media.graphassets.com/output=format:jpg/resize=height:800,fit:max/jbNVCm0SdG3bPXc3rowA",
      alt: "Natera",
    },
  },
  {
    client1: { logo: labcorpLogo, alt: "Labcorp" },
    client2: { logo: fulgentLogo, alt: "Fulgent" },
  },
];

function ASCOAmplificationStrategies() {
  return (
    <>
      <AmplificationStrategiesBanner
        title="ASCO Amplification Strategies"
        description="Find out how to maximize your ASCO conference ROI with our proven digital advertising and video strategies"
        clients={RSNA_CLIENTS}
      />
      <AmplificationStrategiesDetail
        description="Maximize your impact at ASCO with our comprehensive digital and
              video solutions designed to engage and educate Oncology HCPs.
              Utilize pre-conference digital marketing powered by NPI data to
              reach your target audience well before ASCO begins. During the
              conference, we offer strategic digital tactics to drive booth
              traffic, while our on-site video team captures compelling KOL and
              SME testimonials — whether at your booth or an offsite location.
              Post - event, we help re-engage HCPs to ensure your message
              continues to resonate long after ASCO concludes."
        imageUrl={ascoConferenceImg}
      />
      <ASCOWebinarDetails />
      <ASCOAmplificationStrategiesServicesDetails />

      <LatestNewsSection />
      <ContactSection />
    </>
  );
}

export default ASCOAmplificationStrategies;
